import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
/** Product callers supply their effective mode, which can differ from the page's mode. */
export function useAskComposerAppearance(searchMode = SearchMode.SEARCH, { surface } = {}) {
    return searchMode === SearchMode.ASI && surface !== 'teammate' ? 'framed-accent' : 'framed';
}
//# sourceMappingURL=useAskComposerAppearance.js.map